import { useQuery } from "@apollo/client/react";
import { Loader } from "@govlaunch/core";
import { NextPage, NextPageContext } from "next";
import GovernmentPage from "../components/government/GovernmentPage";
import GetGovernmentQuery from "../lib/queries/GetGovernmentQuery";
import {
  IGetGovernmentQuery,
  IGetGovernmentQueryVariables
} from "../lib/queries/__generated__/GetGovernmentQuery.generated";
import slugFromRequest from "../lib/slugFromRequest";
import Error from "./_error";

interface IGovernmentSharingPageProps {
  slug: string | null;
}

const GovernmentSharingPage: NextPage<IGovernmentSharingPageProps> = ({ slug }) => {
  const { loading, data, error } = useQuery<IGetGovernmentQuery, IGetGovernmentQueryVariables>(GetGovernmentQuery, {
    variables: {
      slug: slug || ""
    }
  });
  if (!slug) {
    return <Error statusCode={400} errorMessage="Missing slug" />;
  }
  if (loading) {
    return (
      <div
        css={{
          display: "flex",
          paddingTop: "25%",
          justifyContent: "center"
        }}
      >
        <Loader />
      </div>
    );
  }
  if (!data) {
    return <Error statusCode={404} />;
  }
  if (error) {
    // Let's capture this on AWS logs
    console.error(error);
    return <Error statusCode={500} />;
  }
  if (!data.government) {
    return <Error statusCode={404} />;
  }
  if (!data.government.enableSharing) {
    return <Error statusCode={404} />;
  }
  return <GovernmentPage government={data.government} />;
};

GovernmentSharingPage.getInitialProps = async (ctx: NextPageContext) => {
  return {
    slug: slugFromRequest(ctx.query, ctx.req)
  };
};

export default GovernmentSharingPage;
